export const ANONYMOUS_USER = "anonymousUser";
